import type { SameValuesAs } from '../api/adapters';
import type { LocaleEnum } from '../api/schema';

export enum LOCALE {
  ENGLISH = 'en-gb',
  FRENCH = 'fr-ch',
  GERMAN = 'de-ch',
  ITALIAN = 'it-ch',
}

export type LocaleName = SameValuesAs<`${LOCALE}`, LocaleEnum>;

export const asLocale = (value: string): LOCALE | undefined => Object.values(LOCALE).find(l => String(l) === value);
